import { render, staticRenderFns } from "./AssignTypes.vue?vue&type=template&id=7dc0ed32&"
import script from "./AssignTypes.vue?vue&type=script&lang=js&"
export * from "./AssignTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports